import React from 'react';
import { IconProps } from '../types/types';

const Platinum: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <g clipPath="url(#platinum_svg__a)" fillRule="evenodd" clipRule="evenodd">
            <path d="M13.655.915C6.498.915.695 6.746.695 13.94c0 7.193 5.803 13.025 12.96 13.025 7.158 0 12.96-5.832 12.96-13.025 0-7.194-5.802-13.025-12.96-13.025Z" fill="#596277" />
            <path
                d="M10.828 8.752a.241.241 0 0 0-.234.181l-1.037 4.065h8.201l-1.053-4.065a.241.241 0 0 0-.234-.181h-5.643Zm-.702.062a.724.724 0 0 1 .702-.545h5.643c.33 0 .618.223.701.542l1.054 4.066a.483.483 0 0 1-.468.604h-8.2a.483.483 0 0 1-.469-.602l1.037-4.065Z"
                fill="#fff"
                stroke="#fff"
                strokeWidth={0.25}
            />
            <path
                d="M6.414 13.784a.241.241 0 0 0-.234.182L5.143 18.03h8.201l-1.053-4.066a.242.242 0 0 0-.234-.18H6.414Zm-.702.063a.724.724 0 0 1 .702-.546h5.643c.33 0 .618.223.701.543l1.054 4.066a.483.483 0 0 1-.468.604h-8.2a.483.483 0 0 1-.469-.603l1.037-4.064Z"
                fill="#fff"
                stroke="#fff"
                strokeWidth={0.25}
            />
            <path
                d="M15.238 13.784a.241.241 0 0 0-.234.182l-1.037 4.065h8.202l-1.054-4.066a.241.241 0 0 0-.234-.18h-5.643Zm-.702.063a.724.724 0 0 1 .702-.546h5.643c.33 0 .619.223.701.543l1.054 4.066a.483.483 0 0 1-.467.604h-8.202a.483.483 0 0 1-.467-.603l1.036-4.064Z"
                fill="#fff"
                stroke="#fff"
                strokeWidth={0.25}
            />
        </g>
        <defs>
            <clipPath id="platinum_svg__a">
                <path fill="#fff" transform="translate(.63 .13)" d="M0 0h26.05v26.864H0z" />
            </clipPath>
        </defs>
    </svg>
);

export default Platinum;
